<template>
  <div v-if="items.length > 1" class="btn-group-toggle btn-group">
    <router-link
      v-for="item in items"
      :key="item.route"
      :to="item.route"
      class="btn"
      :class="isActive(item.route) ? 'btn-outline-light' : 'btn-outline-secondary'"
    >
      {{ item.title }}
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Tabs",

  computed: {
    ...mapGetters({
      isAdmin: "auth/isAdmin",
    }),

    items() {
      const items = [
        {
          title: this.$t("pages.institutionsWorkersGroups.list"),
          route: "institutionsWorkersGroups",
        },
      ];

      // childrenGroups route is ROLE_ADMIN-only
      if (this.isAdmin) {
        items.push({ title: this.$t("pages.childrenGroups.list"), route: "childrenGroups" });
      }

      return items;
    },
  },

  methods: {
    isActive(route) {
      return this.$route.path.includes(route);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.btn-outline-light {
  background-color: #fff !important;
  border: #c8ced3 1px solid !important;
  border-radius: $border-radius !important;
  font-weight: 700 !important;
}
</style>
